import React from 'react';
import PropTypes from 'prop-types';

const HalteRow = (props) => {
    const { children } = props;
    return (
        <div className="halte-form__row">
            <div className="halte-form__route">{children[0]}</div>
            <div className="halte-form__submit-btn">{children[1]}</div>
        </div>
    );
};

HalteRow.propTypes = {
    config: PropTypes.object.isRequired,
    children: PropTypes.array.isRequired
};

export default HalteRow;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Group/HalteRow.js